const Mode = {
  TEST: "TEST",
  PRODUCTION: "PRODUCTION"
};

const Status = {
  PAID: "PAID",
  DUE: "DUE",
  DROPPED: "DROPPED",
  DOUBLE_SPEND: "DOUBLE_SPEND",
  LATE_SPEND: "LATE_SPEND",
  REFUNDED: "REFUNDED",
  REFUNDED_PARTIALLY: "REFUNDED_PARTIALLY",
  RUNNING: "RUNNING",
  PROVISIONED: "PROVISIONED"
};

const DropReason = {
  TOO_MANY_ATTEMPTS: "TOO_MANY_ATTEMPTS",
  EXPIRED: "EXPIRED",
  DROPPED_OUT: "DROPPED_OUT"
};

const Target = {
  WINDOW: "WINDOW",
  IFRAME: "IFRAME"
};

const AuthenticationMode = {
  REDIRECTION: "REDIRECTION",
  H2HOTP: "H2HOTP",
  IFRAME: "IFRAME"
};

const PaymentFamily = {
  CARD: "CARD",
  EMI: "EMI",
  NET_BANKING: "NET_BANKING",
  WALLET: "WALLET",
  UPI: "UPI",
  BQR: "BQR",
  UNKNOWN: "UNKNOWN"
};

const ExtendedFamily = {
  CC: "Credit Card",
  DC: "Debit Card",
  "DC-RUPAY": "Debit Card Rupay",
  "CC-RUPAY": "Credit Card Rupay",
  EMI: "EMI",
  NET_BANKING: "Net Banking",
  WALLET: "Wallet",
  UPI: "UPI",
  BQR: "BQR"
};

export {
  Status,
  Mode,
  DropReason,
  Target,
  PaymentFamily,
  ExtendedFamily,
  AuthenticationMode
};
